import * as Utils from "../../utils/Config";
import * as React from "react";
import "./UserCard.scss";
import { IRoleModel } from "../../models/IUserInfo";

interface IUserCard {
    name: string;
    careProviderName?: string;
    organisationNumber: string;
    clinicNumber: string;
    roles?: IRoleModel[];
}

export const UserCard: React.FunctionComponent<IUserCard> = ({ name, careProviderName, organisationNumber, clinicNumber, roles }) => {

    const myWindow: any = window;
    const rolesToolTipId = "roles-tooltip";
    const clinicsToolTipId = "clinics-tooltip";
    const environmentInfo = Utils.ENVIRONMENT_INFO;

    React.useEffect(() => {
        myWindow.$(`#${rolesToolTipId}`).tooltip();
    }, [roles])

    React.useEffect(() => {
        myWindow.$(`#${clinicsToolTipId}`).tooltip();
    }, [careProviderName])

    const roleTooltip = (): string => {
        let tooltip = [];
        if (roles) {
            tooltip.push(`<h5>Roller:</h5>`)
            for (const role of roles) {
                tooltip.push(`<p>${role.description}</p>`);
            }
        }
        return tooltip.join('');
    }

    const clinicTooltip = (): string => {
        let tooltip = [];
        if (roles) {
            tooltip.push(`<h5>Mottagning:</h5>`)
            tooltip.push(`<p>${careProviderName}</p>`);
            tooltip.push(`<p>Organisationsnummer:<br /> ${organisationNumber}</p>`);
            if (clinicNumber) {
                tooltip.push(`<p>Mottagningsnummer:<br /> ${clinicNumber}</p>`);
            }
        }
        return tooltip.join('');
    }

    const onUserCardMouseOverRoles = () => {
        myWindow.$(`#${rolesToolTipId}`).tooltip("enable");
        myWindow.$(`#${rolesToolTipId}`).tooltip("show");
    }

    const onUserCardMouseOverClinic = () => {
        myWindow.$(`#${clinicsToolTipId}`).tooltip("enable");
        myWindow.$(`#${clinicsToolTipId}`).tooltip("show");
    }

    return (
        <div className="user-card text-right">
            <p className="label label-important" hidden={environmentInfo === ""} >{`${environmentInfo}`}</p>
            <p className="text signed-in">Inloggad:</p>
            <p className="text user" id={rolesToolTipId} data-toggle="tooltip" data-html="true" data-original-title={roleTooltip()} onMouseOver={() => onUserCardMouseOverRoles()}>
                {`${name}`}
            </p>
            {
                careProviderName ?
                    <p className="text clinic" id={clinicsToolTipId} data-toggle="tooltip" data-html="true" data-original-title={clinicTooltip()} onMouseOver={() => onUserCardMouseOverClinic()}>
                        {`${careProviderName}`}
                    </p>
                    : null
            }
        </div>
    )
}